import React from "react";
import { Box, Typography } from "@mui/material";
import Eyebrow from "./Eyebrow";

// White card with header (eyebrow + serif title + optional right slot) + body.
export default function Panel({
  eyebrow,
  title,
  right,
  children,
  noBodyPadding = true,
  sx,
}) {
  return (
    <Box
      component="section"
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.brand.border}`,
        borderRadius: 2,
        overflow: "hidden",
        ...sx,
      })}
    >
      {(eyebrow || title || right) && (
        <Box
          sx={(theme) => ({
            px: 2.75,
            py: 1.75,
            borderBottom: `1px solid ${theme.palette.brand.border}`,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            gap: 2,
          })}
        >
          <Box>
            {eyebrow && <Eyebrow sx={{ mb: 0.5, fontSize: 10 }}>{eyebrow}</Eyebrow>}
            {title && (
              <Typography
                variant="h6"
                sx={{ fontSize: 19, fontWeight: 600, lineHeight: 1.2, m: 0 }}
              >
                {title}
              </Typography>
            )}
          </Box>
          {right}
        </Box>
      )}
      <Box sx={{ p: noBodyPadding ? 0 : 2.75 }}>{children}</Box>
    </Box>
  );
}
